import Vue from 'vue'
import VueRouter from 'vue-router'
import DrugInfo from '../components/DrugInfo.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DrugInfo
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to,from,next)=>{
  if(!store.state.isLogin && to.path!=="/login" )
  {
      next("/login")
  }
  else
  {
    next()
  }
})

export default router
